import loadable from '@loadable/component';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {Text, View} from 'react-native';
import styles from './CircleBattery.style';
import { CustomText } from '../../../../../components';
const SVG = loadable(() => import('../../../../../imports/svg'));

export default function CircleBattery(props) {
  const {value , iconWidth=48 , iconHeight=48 , screen  } = props;
  const {t} = useTranslation();

  function iconDetector() {
    switch (true) {
      case value >= 70:
        return 'fullBattery';
      case value >= 50 && value <70 :
        return 'highBattery';
      case value < 50 :
        return 'mediumBattery';
    }
  }

  return (
    <View style={screen=='damageList' ? styles.damagedContainer : styles.container}>
      {!!iconDetector() && <SVG name={iconDetector()} width={iconWidth} height={iconHeight} />}
      <View style={styles.textWrapper}>
          <CustomText size={ screen=='damageList' ? 15 : 20 } color={'#222222'} font={ screen=='damageList' ? '500' : '700'}>
          {value}%
          </CustomText>
        <CustomText mt={-5} color={'#434343'} size={10} font={'400'}>
        {t('battery_charge')}
        </CustomText>
      </View>
    </View>
  );
}
